import * as React from "react"

export default function TicketCheckSolidIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.47 2.195A.667.667 0 0014 2h-12a.667.667 0 00-.667.667v3.666a1.667 1.667 0 010 3.334v3.666a.667.667 0 00.667.667h12a.666.666 0 00.666-.667V9.667a1.666 1.666 0 110-3.334V2.667a.667.667 0 00-.195-.472zm-3.359 4.25l-3.888 3.888L4.889 8l.778-.778 1.556 1.556 3.11-3.111.778.777z"
        fill={props.fill}
      />
    </svg>
  )
}